import { useCallback } from "react";
import { useAsync } from "@shared/hooks";
import { eventService } from "@modules/events/services";
import type { Event, Locality, ApiResponse } from "@/types";

/**
 * Hook to fetch localities for a specific event.
 */
export function useEventLocalities(eventId: string) {
  const fetcher = useCallback(
    () =>
      eventService
        .getEventLocalities(eventId)
        .then(
          (res: ApiResponse<{ event: Event; localities: Locality[] }>) =>
            res.data,
        ),
    [eventId],
  );

  return useAsync<{ event: Event; localities: Locality[] }>(fetcher);
}
